import { protoLib as lib } from '@tock/coretypes';

import coreDefs from '@tock/protos/dist/core.json';

import dashboardDefs from '@tock/protos/dist/dashboard.json';

lib.define('tocktix.messages').addJSON(coreDefs.nested.tocktix.nested.messages.nested);
lib
  .define('tocktix.proto.dashboard')
  .addJSON(dashboardDefs.nested.tocktix.nested.proto.nested.dashboard.nested);
const resolvedRoot = lib.resolveAll();

export default {
  ...resolvedRoot.lookup('tocktix.messages'),
  ...resolvedRoot.lookup('tocktix.messages.enums'),
  ...resolvedRoot.lookup('tocktix.proto.dashboard'),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;
